import React from "react";
import Task from './Task';
import './styles/TaskView.css';
import { Droppable } from 'react-beautiful-dnd';

const TaskColumn = ({ section: { tasks, id, title }, user, setUser}) => {
    return (
        <Droppable droppableId={id}>
            {provided => (
                <div className = "task-column">
                    <h2>{title}</h2>
                    <div className = "task-column-list"
                        {...provided.droppableProps}
                        ref={provided.innerRef}>
                        {tasks.length > 0 && tasks.map((task, index) => (<Task 
                            key={task.taskID.toString()} 
                            task={task}
                            index={index}
                            user={user}
                            setUser={setUser} />))}

                        {provided.placeholder}
                    </div>
                </div>
            )}
        </Droppable>
    )
}

export default TaskColumn
